/* eslint-disable no-debugger,no-unused-vars */
import fixPolyline from '@/tools/fix-polyline'

export function parseRoutingV8Resp(routes) {
  return routes.map(routeJson => Route.fromV8Respond(routeJson))
}
class Section {
  constructor(sectionJson) {
    this.sectionJson = Object.assign({}, sectionJson)
    this.shape = this.getShape()
    this.actions = new Actions(this)
    this.summary = sectionJson.summary
    this.summary.tollCost = this.getTollCost()
    delete this.sectionJson.polyline
  }
  getShape() {
    let polyline = fixPolyline.decode(this.sectionJson.polyline).polyline
    let shape = []
    polyline.forEach(item => { shape.push(...item) })
    return Object.freeze(shape)
  }
  
  getTollCost() {
    try {
      let tollCost = 0
      let tolls = this.sectionJson.tolls || []
      tolls.forEach(item => {
        item.fares.forEach(fares => {
          tollCost += fares.price.value
        })
      })
      return tollCost
    } catch {
      return 0
    }
  }
}

class Actions {
  constructor(section) {
    this._section = section
    this._json = section.sectionJson.actions.map(item => {
      item.position = {
        latitude: this._section.shape[item.offset * 2],
        longitude: this._section.shape[item.offset * 2 + 1]
      }
      return item
    })
  }

  get() {
    return this._json
  }
}

export class Route {
  constructor(routeJson) {
    this.routeJson = routeJson
    sessionStorage.setItem(this._key(), JSON.stringify(routeJson))
    this.sections = Object.freeze(routeJson.sections.map(x => new Section(x)))
    this.shape = this.getShape()
    this.waypoint = this.getWaypoint()
    this.id = this.routeJson.id
    this.summary = {
      distance: this.getAllData('length'),
      duration: this.getAllData('duration'),
      baseDuration: this.getAllData('baseDuration'),
      totalCost: this.getAllData('tollCost'),
      departure: this.waypoint[0].time,
      arrival: this.waypoint[this.waypoint.length - 1].time
    }
  }

  getWaypoint() {
    try {
      let waypoint = []
      let shapeLen = 0
      this.sections.forEach((item, index) => {
        let departure = item.sectionJson.departure
        let shape = item.shape
        let shapeIndex = index === 0 ? 0 : shapeLen
        waypoint.push({
          mappedPosition: { latitude: this.shape[shapeIndex], longitude: this.shape[shapeIndex + 1] },
          originalPosition: { latitude: departure.place.originalLocation.lat, longitude: departure.place.originalLocation.lng },
          mappedRoadName: departure.place.name || '',
          shapeIndex: index === 0 ? 0 : shapeLen / 2,
          time: departure.time
        })
        shapeLen += shape.length
        if (index === this.sections.length - 1) {
          let arrival = item.sectionJson.arrival
          waypoint.push({
            mappedPosition: { latitude: this.shape[this.shape.length - 2], longitude: this.shape[this.shape.length - 1] },
            originalPosition: { latitude: arrival.place.originalLocation.lat, longitude: arrival.place.originalLocation.lng },
            mappedRoadName: arrival.place.name || '',
            shapeIndex: (shapeLen - 2) / 2,
            time: arrival.time
          })
        }
      })
      return waypoint
    } catch {
      throw Error('waypointList error !')
    }
  }

  getShape() {
    let shape = []
    this.sections.forEach(item => {
      shape = shape.concat(item.shape)
    })
    return Object.freeze(shape)
  }

  getAllData(key) {
    let data = 0
    this.sections.forEach(item => {
      data += item.summary[key]
    })
    return data
  }

  _key() {
    return `route@${this.id}`
  }

  originJson() {
    return JSON.parse(sessionStorage.getItem(this._key()))
  }

  static fromV8Respond(routeV8Json) {
    return new Route(routeV8Json)
  }
}
